export const BOT_SCORE_COOKIE_NAME = 'X-NW-sig_lvl';
export const IS_BOT_COOKIE_NAME = 'X-NW-bt';
export const IS_BOT_USER_AGENT_COOKIE_NAME = 'X-NW-ua_bt';
export const IS_VERIFIED_BOT_COOKIE_NAME = 'X-NW-f_opt';
